import { render } from "./ExpandableRadio.vue?vue&type=template&id=7bc70e63&scoped=true"
import script from "./ExpandableRadio.vue?vue&type=script&lang=js"
export * from "./ExpandableRadio.vue?vue&type=script&lang=js"

import "./ExpandableRadio.vue?vue&type=style&index=0&id=7bc70e63&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7bc70e63"

export default script